import { AGRNT_AUTH_CODE } from '@/pages/agent/js/enum'
import SenceCodeMap from './SenceCodeMap.js'

let cachedAgentAuthList = null
const auth = {
  inserted(el, binding, vnode) {
    if (binding.value) {
      if (binding.value instanceof Array) {
        const { $root: vm } = vnode.context
        const agentAuthList =
          cachedAgentAuthList ??
          (cachedAgentAuthList = vm.$store.state.agentAuthList ?? [])
        const isAgentGray = vm.$store.state.isAgentGray
        console.log(isAgentGray, agentAuthList, '=====')
        // 检查用户是否有权限
        if (!userHasAuth(agentAuthList, binding.value) && isAgentGray) {
          if (el && el.parentNode) {
            // 如果没有权限，移除元素
            el.parentNode.removeChild(el)
          }
        }
      } else {
        throw new Error('auth directive only accepts array param')
      }
    }
  },
}
// 判断code是否存在权限列表中
export const userHasAuth = (authList, roleCode) => {
  if (!authList || !roleCode) {
    return false
  }
  const roleCodeList = authList.map(item => item.permCode)
  return roleCode instanceof Array
    ? roleCode.some(element => roleCodeList.includes(element))
    : roleCodeList.includes(roleCode)
}
export default auth

export function isStoreSelfChange(authList, agentSetting, isRemind) {
  if (!agentSetting) return false
  if (agentSetting.agentPermGray) {
    if (!authList) return false
    const roleCode = !isRemind
      ? AGRNT_AUTH_CODE.AGENTS_INDEPENDENTLY_BIND_STORES
      : AGRNT_AUTH_CODE.STORE_BINDING_REMINDER
    const isAuth = userHasAuth(authList, roleCode)
    return isAuth
  } else {
    return !isRemind
      ? agentSetting.storeSelfChange
      : agentSetting.storeBindRemind
  }
}

export const authSenceMap = (list, sence) => {
  return list.map(i => {
    let permCode = SenceCodeMap[sence]?.[i.permCode] || i.permCode
    return {
      ...i,
      permCode,
    }
  })
}
